module.exports = __webpack_public_path__ + "img/VOLOGOD.c54be3de.png";